// Libs
import Vue from "vue";
import VeeValidate from "vee-validate";
import cssVars from "css-vars-ponyfill";

// Components
import WidgetBugreport from "./App.vue";

// Plugins
import vuetify from "@/plugins/vuetify";
import themes from "@/plugins/themes";

// Store
import store from "./store/store";

// Mixins
import Mess from "@/mixins/Mess";
import Locale from "@/mixins/Locale";

// Utils
import { getTheme } from "@/utils/get-theme";
import detectBrowser from "@/utils/detect-browser";

if (detectBrowser() === "ie") {
  document.body.classList.add("browser-ie");
  cssVars();
}

Vue.use(VeeValidate);
Vue.mixin(Mess);
Vue.mixin(Locale);

Vue.config.productionTip = false;

document.body.insertAdjacentHTML(
  "beforeend",
  "<div id='vue-widget-bugreport'></div>"
);

new Vue({
  vuetify,
  store,
  created() {
    this.$vuetify.theme.themes.light = getTheme(window.theme, themes);
  },
  render: h => h(WidgetBugreport)
}).$mount("#vue-widget-bugreport");
